// src/utils/arrayUtils.js

// Random shuffle (Fisher–Yates) — setiap call akan bagi susunan baru
export const shuffleArray = (arr = []) => {
    const a = Array.isArray(arr) ? [...arr] : [];
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
};

// Random tapi "stable" ikut seed (contoh: seed ikut tarikh)
export const seededShuffleArray = (arr = [], seed = 1) => {
    const a = Array.isArray(arr) ? [...arr] : [];
    let s = Number(seed) || 1;

    const rand = () => {
        // LCG simple
        s = (s * 1664525 + 1013904223) % 4294967296;
        return s / 4294967296;
    };

    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(rand() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
};

// Helper seed ikut hari (stable sehari)
export const daySeed = (d = new Date()) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const da = String(d.getDate()).padStart(2, "0");
    return Number(`${y}${m}${da}`);
};
